// extracted by mini-css-extract-plugin
export default {"container":"ClientData_container__xMhM2","verticalContainer":"ClientData_verticalContainer__RK7dr"};